module.exports = __webpack_public_path__ + "assets/upload_icon.575de1f1.svg";